module.exports = __webpack_public_path__ + "static/media/Angry_ip_scan_logo.svg.82856665.png";